<template>
	<div>
		<v-data-table v-if="data.items" :headers="headers" :items="data.items" :hide-actions="true" :loading="loading">
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template slot="items" slot-scope="props">
				<td class="justify-center text-xs-left pa-0">
					<v-btn fab icon small @click="handleMoveUp(props.item)"><v-icon>arrow_upward</v-icon></v-btn>
					<v-btn fab icon small @click="handleMoveDown(props.item)"><v-icon>arrow_downward</v-icon></v-btn>
				</td>
				<td>
					<v-img width="100" v-if="props.item.coverUrl" :src="props.item.coverUrl" class="white elevation-0"></v-img>
				</td>
				<td>
					{{ props.item.title }}
				</td>
				<td class="justify-center text-xs-center pa-0">
					<v-btn fab icon small @click="handleEdit(props.item)"><v-icon>edit</v-icon></v-btn>
					<v-btn fab icon small @click="handleDelete(props.item)"><v-icon>delete</v-icon></v-btn>
				</td>
			</template>
			<template slot="no-data">
 				<v-btn color="primary" @click="handlePageChange(1)">Reset</v-btn>
			</template>
		</v-data-table>

	    <div class="pt-2 pb-5">
			<v-pagination v-model="data.page" :length="pages" :total-visible="6"></v-pagination>
	    </div>

		<v-btn fixed dark fab bottom right color="primary" @click="handleAdd">
			<v-icon>add</v-icon>
        </v-btn>

		<v-dialog v-model="toggle.dialog" scrollable max-width="690px" :persistent="toggle.contentPicker">
		    <v-card :class="{'-loading': toggle.dialogLoading}">
		        <v-card-title class="headline grey lighten-2" primary-title>
		            {{ formTitle }}
		        </v-card-title>
		        <v-card-actions>
		            <v-spacer></v-spacer>
		            <v-btn color="blue darken-1" flat @click="importYouTube">YouTube</v-btn>
		            <v-btn color="blue darken-1" flat @click="importJeban">Jeban.com</v-btn>
		        </v-card-actions>
		        <v-card-text>
		            <v-container grid-list-md class="py-0">
		            	<v-form ref="form" v-model="valid" class="pb-5" lazy-validation>
			                <v-layout wrap>
			                    <v-flex xs12>
			                        <v-text-field v-model="pinnedContent.title" label="Title"></v-text-field>
			                    </v-flex>
			                    <v-flex xs12>
			                    	<cover-image-upload 
			                    		class="pa-0" 
			                    		label="Image" 
			                    		v-model="pinnedContent.coverUrl"
			                    		@upload-success="handleCoverUploadSuccess">
		                    		</cover-image-upload>
			                    </v-flex>
			                    <v-flex xs12>
									<v-menu offset-y :close-on-content-click="false" v-model="toggle.mainColor">
										<v-text-field class="main-color-input color-input" v-model="pinnedContent.mainColor" slot="activator" label="Main Color" prepend-icon="color_lens"></v-text-field>
										<v-card>
											<v-card-text class="pa-1">
												<color-picker :value="pinnedContent.mainColor" @input="handleUpdateMainColor" class="elevation-0"></color-picker>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer><v-btn flat @click="toggle.mainColor = false">Close</v-btn>
											</v-card-actions>
										</v-card>
									</v-menu>
									<v-menu offset-y :close-on-content-click="false" v-model="toggle.subColor">
										<v-text-field class="main-color-input color-input" v-model="pinnedContent.subColor" slot="activator" label="Sub Color" prepend-icon="color_lens"></v-text-field>
										<v-card>
											<v-card-text class="pa-1">
												<color-picker :value="pinnedContent.subColor" @input="handleUpdateSubColor" class="elevation-0"></color-picker>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer><v-btn flat @click="toggle.subColor = false">Close</v-btn>
											</v-card-actions>
										</v-card>
									</v-menu>
			                    </v-flex>
			                    <v-flex xs12>
			                        <v-text-field prepend-icon="link" type="url" v-model="pinnedContent.targetUrl" label="Target"></v-text-field>
			                    </v-flex>
			                    <v-flex xs12>
			                        <v-text-field prepend-icon="fab fa-youtube" v-model="pinnedContent.youtubeVideoId" label="Youtube Id"></v-text-field>
			                    </v-flex>
			                </v-layout>
			            </v-form>
		            </v-container>
		        </v-card-text>
				<v-divider></v-divider>
		        <v-card-actions>
		            <v-spacer></v-spacer>
		            <v-btn color="blue darken-1" flat @click="toggle.dialog = false">Cancel</v-btn>
		            <v-btn color="blue darken-1" flat :loading="saving" @click="handleSave">Save</v-btn>
		        </v-card-actions>
		    </v-card>
		</v-dialog>

		<related-content-list-picker
			:contents="selectedContents"
			@action="handlePickerAction"
			@close="handleClosePicker">
		</related-content-list-picker>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import CoverImageUpload from '@/components/CoverImageUpload.vue'
	import RelatedContentListPicker from '@/components/RelatedContentListPicker.vue'
	import { Sketch } from 'vue-color'

	export default {
		components: {
			'cover-image-upload': CoverImageUpload,
			'related-content-list-picker': RelatedContentListPicker,
			'color-picker': Sketch
		},
		props: {
			communityId: {
				type: Number,
				default: 0
			}
		},
		data () {
			return {
				headers: [
					{
						sortable: false,
						width: 120
					},
					{
						text: 'Image',
						align: 'center',
						sortable: false,
						width: '100'
					},
					{
						text: 'Title',
						align: 'left',
						sortable: false,
					},
					{ 
						align: 'center', 
						sortable: false,
						width: '150'
					}
				],
				currentYmd: (new Date().toISOString().substring(0, 19).replace('T', ' ')),
	            data: {
	                page: 1,
	                totalRecords: 0,
	                items: []
	            },
				pageSize: 10,
				loading: true,
				saving: false,
				valid: true,
				formTitle: 'New Pinned Content',
				pinnedContent: {
					id: null,
					communityId: this.communityId,
					title: '',
					coverUrl: '',
					responsiveCoverFile: '',
					youtubeVideoId: '',
					targetUrl: '',
					mainColor: '',
					subColor: '',
					seqNo: 0
				},
				rules: {
					text: [
						v => !!v || 'Field is required'
					],					
					number: [
						v => !!v || 'Field is required',
						v => (parseInt(v) > 0) || 'Value must be greater than 0'
					],					
				},
				toggle: {
					dialog: false,
					dialogLoading: false,
					contentPicker: false,
					mainColor: false,
					subColor: false
				}
			}
		},
		computed: {
			maxSeqNo () {
				return this.data.items.length ? this.data.items.map(i => i.seqNo).reduce((a, b) => Math.max(a, b)) : 0
			},
        	apiUrl () {
        		return `${config.BASE_URL}/community/${this.communityId}/pinnedContent`
        	}, 
			pages () {
				if (this.pageSize == null || this.data.totalRecords == null) {
					return 0
				}
				return Math.ceil(this.data.totalRecords / this.pageSize)
			},
			selectedContents () {
				return this.toggle.contentPicker ? [] : null
			}
		},
		created () {
			this.handlePageChange(1)
		},
		methods: {
			contentLink (content) {
				switch (content.contentType) {
					case 'CHECK':
						return `/beautycheck/${content.id}`
						break
					case 'SPOTLIGHT':
						return `/spotlight/${content.slug}`
						break
					default:
						return `/${content.contentType.toLowerCase()}/${content.id}`
						break
				}
			},
			resetItemOnDialog () 
			{
				return new 
					Promise((resolve) => {
						this.pinnedContent = {
							id: null,
							communityId: this.communityId,
							title: '',
							coverUrl: '',
							responsiveCoverFile: '',
							youtubeVideoId: '',
							targetUrl: '',
							mainColor: '',
							subColor: '',
							seqNo: this.maxSeqNo + 1
						}

						resolve(true)
					})
			},
	    	handleAdd ()
	    	{
	    		this.resetItemOnDialog()
	    			.then(() => {
	    				this.formTitle = 'New Pinned Content'
	    				this.toggle.dialog = true
	    			})
	    	},
	    	handleEdit (itemRow)
	    	{
				axios.get(`${this.apiUrl}/${itemRow.id}`)
					.then((response) => {
						this.pinnedContent = response.data.data
						this.formTitle = 'Edit Pinned Content'
						this.toggle.dialog = true
					})
	    	},
	        handleDelete (itemRow)
	        {
	        	var id = itemRow.id;

	        	this.$swal({
	        		icon: 'warning',
	        		text: `Remove "${itemRow.title}" ?`,
	        		showCancelButton: true
	        	}).then(response => {
	        		if (response.value) {
			    		axios.delete(`${this.apiUrl}/${itemRow.id}`)
				    		.then((response) => {
				    			this.handlePageChange(this.data.page)
				    		}).catch((error) => {
				    			this.$store.commit(types.SET_ERROR_MSG, 'Could not remove item.')
							})
	        		}
	        	})
	        },
	        handleMoveUp (itemRow) 
	        {
	        	var id = itemRow.id;

	    		axios.put(`${this.apiUrl}/${itemRow.id}/moveUp`)
		    		.then((response) => {
		    			this.handlePageChange(this.data.page)
		    		}).catch((error) => {
						this.$store.commit(types.SET_ERROR_MSG, 'Could not re-order item.')
					})
	        },
	        handleMoveDown (itemRow)
	        {
	        	var id = itemRow.id;

	    		axios.put(`${this.apiUrl}/${itemRow.id}/moveDown`)
		    		.then((response) => {
		    			this.handlePageChange(this.data.page)
		    		}).catch((error) => {
						this.$store.commit(types.SET_ERROR_MSG, 'Could not re-order item.')
					})
	        },
	        handlePageChange (pageNum)
	        {
	            var apiUrl = this.apiUrl;

            	apiUrl += `/paginate?limit=${this.pageSize}`
	            if (parseInt(pageNum, 10) > 1) {
	                apiUrl += `&page=${parseInt(pageNum, 10)}`
	            }

	            this.loading = true

	            axios.get(apiUrl)
	                .then((response) => {
	                    this.data = response.data.data
	                    this.data.items = response.data.data.pinnedContentList

	                    this.loading = false
	                });
	        },
	        handleSave ()
	        {
		    	if (this.$refs.form.validate()) {
			    	if (this.pinnedContent.id) {
				    	axios.put(`${this.apiUrl}/${this.pinnedContent.id}`, this.pinnedContent)
				    		.then((response) => {
				    			if ((response.data.httpStatusCode == 200) || (response.data.httpStatusCode == 201)) {
				    				this.handlePageChange(this.data.page)
				    				this.toggle.dialog = false
				    			} else {
				    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
				    			}
				    		}).catch(function (error) {

							});
			    	} else {
				    	axios.post(this.apiUrl, this.pinnedContent)
				    		.then((response) => {
				    			if ((response.data.httpStatusCode == 200) || (response.data.httpStatusCode == 201)) {
				    				this.handlePageChange(1)
				    				this.toggle.dialog = false
				    			} else {
				    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
				    			}
				    		}).catch(function (error) {

							});
			    	}
			    }
	        },
			handlePickerAction (content) {
				this.pinnedContent.title = content.title
				this.pinnedContent.coverUrl = content.coverUrl
				this.pinnedContent.responsiveCoverFile = content.responsiveCoverFile
				this.pinnedContent.youtubeVideoId = ''
				this.pinnedContent.targetUrl = this.contentLink(content)

				this.toggle.contentPicker = false
			},
			handleClosePicker () {
				this.toggle.contentPicker = false
			},
	        async importYouTube () {
				const { value: url } = await this.$swal.fire({
					title: 'Input YouTube link',
					input: 'url',
					inputPlaceholder: 'Enter YouTube link'
				})

				if (url) {
					this.toggle.dialogLoading = true
					fetch(`https://opengraph.io/api/1.1/site/${encodeURIComponent(url)}?app_id=c92161ab-6b55-4e8f-b43f-af8d2eac203d`)
						.then(resp => resp.json())
						.then(data => {
							// document.getElementById("result").innerHTML = JSON.stringify(data, undefined, 4)

							let youTubeGetID = (url) => {
							   url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
							   return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0]
							}

							this.pinnedContent.title = data.openGraph.title
							this.pinnedContent.coverUrl = data.openGraph.image.url
							this.pinnedContent.responsiveCoverFile = ''
							this.pinnedContent.youtubeVideoId = youTubeGetID(data.openGraph.url)
							this.pinnedContent.targetUrl = data.openGraph.url

							this.toggle.dialogLoading = false
			    		})
				}
	        },
	        importJeban () {
	        	this.toggle.contentPicker = true
	        },
	        handleCoverUploadSuccess (response) {
	        	this.pinnedContent.responsiveCoverFile = response.responsiveCoverFile
	        },
			handleUpdateMainColor (e) 
			{
				this.pinnedContent.mainColor = e.hex
			},
			handleUpdateSubColor (e) 
			{
				this.pinnedContent.subColor = e.hex
			},
		},
		watch: {
			'data.page' (to, from) {
				if (to !== from) {
					this.handlePageChange(to)
				}
			},
			communityId (value) {
				this.handlePageChange(1)
			}
		},
		filters: {
			truncate (text, stop, clamp) {
			    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
			}
		}
	}
</script>

<style lang="scss">
	table {
		tbody {
			tr {
				td {
					a {
						text-decoration: none !important;
						&:hover {
							text-decoration: none !important;
						}
					}
					&.-unpublished {
						opacity: .4;
					}
				}
			}
		}
	}
	.v-icon[class*="fa-"] {
		font-size: 18px;
	}
	.score-input {
		width: 290px;
	}
	.-loading {
		opacity: .4;
	}

	.related-content-list-picker {
		z-index: 9999;
	}
</style>